import React from 'react';
import MarketPulzeLogo from './MarketPulzeLogo';
import { s } from '../styles/shared';

const Footer = ({ setPage, setShowInvite }) => {
  const year = new Date().getFullYear();

  const cols = [
    {
      title: 'Product',
      links: [
        { label: 'Market Dashboard', page: 'market'    },
        { label: 'Stock Screener',   page: 'screener'  },
        { label: 'Calculator',       page: 'calculator'},
        { label: 'Stock Analysis',   page: 'home'      },
        { label: 'Request Invite',   page: 'waitlist'  },
      ]
    },
    {
      title: 'Company',
      links: [
        { label: 'About Us',  page: 'about'   },
        { label: 'Contact',   page: 'contact'  },
        
      ]
    },
    {
      title: 'Legal',
      links: [
        { label: 'Privacy Policy',    page: 'privacy' },
        { label: 'Terms of Service',  page: 'terms'   },
        { label: 'Disclaimer',        page: 'terms'   },
              ]
    },
    {
      title: 'Data Sources',
      // Full vendor list + DPA-style disclosure lives in Privacy Policy §4
      // (single source of truth) — footer just points there now, not a
      // second, independently-drifting copy of the same list.
      links: [
        { label: 'View Data Sources', page: 'privacy' },
        ]
    },
  ];

  const link = { background: 'none', border: 'none', color: '#475569', cursor: 'pointer', fontSize: '0.83rem', padding: '0.2rem 0', display: 'block', textAlign: 'left', textDecoration: 'none', transition: 'color 0.15s', fontFamily: 'inherit' };

  return (
    <footer style={{ background: 'rgba(5,10,22,0.95)', borderTop: '1px solid rgba(0,212,255,0.07)', marginTop: '5rem' }}>
      {/* Main footer grid */}
      <div style={{ maxWidth: s.container.maxWidth, margin: '0 auto', padding: '3.5rem 1.5rem 2.5rem' }}>
        <div className="footer-grid" style={{ display: 'grid', gap: '2.5rem' }}>

          {/* Brand column */}
          <div>
            <div style={{ display: 'flex', alignItems: 'center', gap: '0.6rem', marginBottom: '1rem' }}>
              <MarketPulzeLogo size={30} />
              <div style={{ fontSize: '1.1rem', fontWeight: 900, background: 'linear-gradient(135deg,#00ff88,#00d4ff)', WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent' }}>
                MarketPulze
              </div>
            </div>
            <p style={{ fontSize: '0.82rem', color: '#334155', lineHeight: 1.75, margin: '0 0 1.25rem' }}>
              Algorithmic stock screening for US equities. 15-minute delayed data. Invite-only beta.
            </p>
            {/* Status badge */}
            <div style={{ display: 'inline-flex', alignItems: 'center', gap: '0.4rem', padding: '0.3rem 0.75rem', background: 'rgba(0,255,136,0.06)', border: '1px solid rgba(0,255,136,0.15)', borderRadius: '20px' }}>
              <span style={{ width: 6, height: 6, borderRadius: '50%', background: '#00ff88', display: 'inline-block', boxShadow: '0 0 6px #00ff88' }} />
              <span style={{ fontSize: '0.7rem', color: '#00ff88', fontWeight: 700 }}>All Systems Operational</span>
            </div>
          </div>

          {/* Nav columns */}
          {cols.map(col => (
            <div key={col.title}>
              <h4 style={{ fontSize: '0.72rem', fontWeight: 800, color: '#f8fafc', letterSpacing: '0.1em', textTransform: 'uppercase', margin: '0 0 1.1rem' }}>{col.title}</h4>
              {col.links.map(l => (
                l.href ? (
                  <a key={l.label} href={l.href} target="_blank" rel="noopener noreferrer"
                    style={link}
                    onMouseEnter={e => e.target.style.color = '#00d4ff'}
                    onMouseLeave={e => e.target.style.color = '#475569'}>
                    {l.label}
                  </a>
                ) : (
                  <button key={l.label} onClick={() => l.label === 'Request Invite' ? setShowInvite && setShowInvite(true) : setPage(l.page)}
                    style={link}
                    onMouseEnter={e => e.target.style.color = '#00d4ff'}
                    onMouseLeave={e => e.target.style.color = '#475569'}>
                    {l.label}
                  </button>
                )
              ))}
            </div>
          ))}
        </div>

        {/* Disclaimer */}
        <div style={{ marginTop: '3rem', padding: '1.25rem 1.5rem', background: 'rgba(255,170,0,0.04)', border: '1px solid rgba(255,170,0,0.1)', borderRadius: '10px' }}>
          <p style={{ fontSize: '0.68rem', color: '#52525b', margin: 0, lineHeight: 1.75 }}>
            <strong style={{ color: '#78716c' }}>⚠️ Investment Disclaimer:</strong> MarketPulze is for informational and educational purposes only. Nothing on this platform constitutes financial, investment, legal, or tax advice. All analysis, scores, and signals are generated by automated algorithms and do not account for your personal financial situation, risk tolerance, or investment objectives. Past performance is not indicative of future results. Investing involves risk, including possible loss of principal. Always conduct your own research and consult a qualified financial advisor before making investment decisions. MarketPulze is not a registered investment advisor or broker-dealer.
          </p>
        </div>

        {/* Third-party disclaimer */}
        <div style={{ marginTop: '1.5rem', fontSize: '0.65rem', color: '#1e293b', lineHeight: 1.7 }}>
          Market data is provided by licensed third-party data providers. MarketPulze is not affiliated with, endorsed by, or sponsored by any data provider. See our Terms of Service for full data attribution.
        </div>

        {/* Bottom bar */}
        <div style={{ marginTop: '2rem', paddingTop: '1.5rem', borderTop: '1px solid rgba(255,255,255,0.04)', display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: '1rem' }}>
          <p style={{ fontSize: '0.75rem', color: '#334155', margin: 0 }}>
            © {year} MarketPulze. All rights reserved.
          </p>
          <p style={{ fontSize: '0.72rem', color: '#1e293b', margin: 0 }}>
            Market data provided by licensed partners · Prices may be delayed
          </p>
        </div>
      </div>

      <style>{`
        .footer-grid {
          grid-template-columns: 200px repeat(4, 1fr);
        }
        @media (max-width: 900px) {
          .footer-grid {
            grid-template-columns: 1fr 1fr !important;
          }
        }
        @media (max-width: 600px) {
          .footer-grid {
            grid-template-columns: 1fr !important;
          }
        }
      `}</style>
    </footer>
  );
};

export default Footer;
